import { Grid, Image } from "antd-mobile";
import img from "app/img";
import { useI18n } from "i18n/useI18n";
import { useTranslation } from "react-i18next";

export default function Slogan() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        margin: "5px 30px 20px 30px",
        fontSize: 12,
        color: "#999",
        textAlign: "center",
      }}
    >
      <Image src={img.login_slogan} style={{ margin: "0 20px 10px 20px" }} />
      <Grid columns={3}>
        <span>{t("slogan.index.180776-0")}</span>
        <span>{t("slogan.index.180776-1")}</span>
        <span>{t("slogan.index.180776-2")}</span>
      </Grid>
    </div>
  );
}
